/**
 * Asynchronously loads the component for Edit Notifications
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
